import { useMutation } from '@apollo/client';
import CREATE_USER_CONTENT_SHARE_SUBSCRIPTION from 'graphql/mutations/userContentShareSubscriptions/CreateUserContentShareSubscription.graphql';

export default function useCreateUserContentShareSubscriptionMutation() {
  return useMutation(CREATE_USER_CONTENT_SHARE_SUBSCRIPTION);
}
